import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { I as InlineMessage } from '../Text/InlineMessage/InlineMessage-BFcYfOBZ.js';

const inputFocusStyles = /*#__PURE__*/css(["", " outline-offset:1px;"], focusOutline);
const inputStyles = /*#__PURE__*/css(["", ";background:unset;border:unset;border-color:unset;box-shadow:unset;border-radius:", ";color:", ";position:relative;width:100%;align-self:center;transition:unset;margin-block-start:0;margin-block-end:0;min-width:0;appearance:none;", " @media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}::placeholder{color:", ";opacity:1;}:disabled{cursor:not-allowed;outline:none;opacity:1;color:", ";box-shadow:none;border-color:", ";background-color:", ";}:focus,:focus-within{outline:none;}&&[type=\"color\"]{align-self:auto;}"], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.form.input.radius, ({
  theme
}) => theme.form.input.color, isMobile(css(["", ";font-size:", ";"], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.form.input.mobile.fontSize)), ({
  theme
}) => theme.form.input.placeholderColor, ({
  theme
}) => theme.form.input.disabled.color, ({
  theme
}) => theme.form.input.disabled.borderColor, ({
  theme
}) => theme.form.input.disabled.bg);
const styleInputMixin = /*#__PURE__*/css(["", " box-sizing:border-box;min-height:calc(", " - 6px);height:auto;padding:0 calc(", " - 2px);::-ms-clear{display:none;width :0;height:0;}::-ms-reveal{display:none;width :0;height:0;}::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration{display:none;}::-webkit-calendar-picker-indicator{background:none;}:focus{background-color:", ";}", " ", " ", " ", ""], inputStyles, ({
  theme
}) => theme.form.input.height, ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.palette.gray[0], ({
  prefix,
  suffix,
  theme,
  $ignoreTextDirection
}) => prefix && !suffix && css(["/*! @noflip */ border-radius:0 ", " ", " 0;", " border-inline-start:none;padding-inline-start:0px;"], theme.form.input.radius, theme.form.input.radius, !$ignoreTextDirection && css(["/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ border-radius:", " 0 0 ", ";}"], theme.form.input.radius, theme.form.input.radius)), ({
  prefix,
  suffix,
  theme,
  $ignoreTextDirection
}) => !prefix && suffix && css(["/*! @noflip */ border-radius:", " 0 0 ", ";", " border-inline-end:none;padding-inline-end:0px;"], theme.form.input.radius, theme.form.input.radius, !$ignoreTextDirection && css(["/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ border-radius:0 ", " ", " 0;}"], theme.form.input.radius, theme.form.input.radius)), ({
  prefix,
  suffix
}) => prefix && suffix && css(["padding-inline-start:0px;padding-inline-end:0px;border-radius:0;"]), isMobile(css(["min-height:calc(", " - 6px);"], ({
  theme
}) => theme.form.input.mobile.height)));
const InputValidationMessage = /*#__PURE__*/styled(InlineMessage).withConfig({
  componentId: "sc-storm-ui-30075085__sc-14md3vx-0"
})(["margin-top:0;margin-bottom:0;"]);
InputValidationMessage.displayName = 'InputValidationMessage';
const InputGroup = /*#__PURE__*/styled(({
  className,
  children,
  inputGroupRef,
  dir
}) => /*#__PURE__*/React__default.createElement("div", {
  dir: dir,
  className: className,
  ref: inputGroupRef
}, children)).withConfig({
  componentId: "sc-storm-ui-30075085__sc-14md3vx-1"
})(["background:", ";border:", ";border-color:", ";box-shadow:", ";box-sizing:border-box;border-radius:", ";color:", ";min-width:", ";padding:2px;display:flex;", " ", " ", " :focus-within{", "}> input{", "}"], ({
  theme,
  disabled
}) => disabled ? theme.form.input.disabled.bg : theme.form.input.bg, ({
  theme
}) => theme.form.input.border, ({
  theme,
  disabled
}) => disabled ? theme.form.input.disabled.borderColor : theme.form.input.borderColor, ({
  theme
}) => theme.form.input.boxShadow, ({
  theme
}) => theme.form.input.radius, ({
  theme,
  disabled
}) => disabled ? theme.form.input.disabled.color : theme.form.input.color, ({
  fullWidth,
  theme
}) => fullWidth ? 'auto' : theme.form.input.minWidth, ({
  $statusType,
  theme
}) => $statusType === 'error' && css(["border-color:", ";box-shadow:", ";"], theme.form.input.error.borderColor, theme.form.input.error.boxShadow), ({
  $statusType,
  theme
}) => $statusType === 'warning' && css(["border-color:", ";"], theme.form.input.warning.borderColor), ({
  $statusType,
  theme
}) => $statusType === 'success' && css(["border-color:", ";"], theme.form.input.success.borderColor), inputFocusStyles, styleInputMixin);
InputGroup.displayName = 'InputGroup';

export { InputGroup as I, InputValidationMessage as a, inputStyles as b, inputFocusStyles as i, styleInputMixin as s };
//# sourceMappingURL=InputFormGroup.styles-B4ycY_k0.js.map
